import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study requires a webcam", "Screenout", "User failed webcam check - $error_message$", "app.error.webcam")